<template>
  <div class="card">
    <img :src="imageSource" :alt="imageAlt" />
    <h4>{{ header }}</h4>
    <p>{{ description }}</p>
    <div class="button">
      <a :href="cardLink" target="_blank">Learn More</a>
    </div>
  </div>
</template>

<script>
export default {
  name: "CardComponent",
  props: {
    header: {
      type: String,
      required: false,
    },
    description: {
      type: String,
      required: false,
    },
    imageSource: {
      type: String,
      required: false,
    },
    imageAlt: {
      type: String,
      required: false,
      default: "Card Image",
    },
    cardLink: {
      type: String,
      required: false,
    },
  },
};
</script>

<style scoped>
.card {
  max-width: 320px;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 100%;
  border-radius: 8px;
  border: 2px solid var(--secondary-gray);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background-color: #f0f0f0;
  overflow: hidden;
  text-align: center;
}
p {
  font-size: 1.25em;
  margin: 0 auto;
}
.button {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: flex-end;

  a {
    justify-self: flex-end;
    display: block;
    text-align: center;
    margin: 15px;
    padding: 10px;
    background-color: transparent;
    color: var(--main-blue);
    text-decoration: none;
    border-radius: 5px;
    border: 2px solid var(--main-blue);
    font-family: PT Serif, serif;
  }
  a:hover {
    background-color: var(--main-blue);
    color: white;
    transition: background-color 0.3s ease;
  }
}
img {
  max-height: 320px;
  max-width: 100%;
}
.card:hover {
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2);
  transform: translateY(-4px);
  transition: all 0.3s ease;
}
@media (max-width: 550px) {
  p {
    font-size: 1em;
    padding: 0 1em;
  }
}
@media (max-width: 480px) {
  .card {
    width: 90%;
    max-width: none;
  }
  h4 {
    font-size: 1.25em;
  }
}
</style>
